<template>
  <div class="customer-select">
    <sky-select width="350"
                :disabled="disabled"
                autofocus
                filterable
                remote
                :clearable="clearable"
                :props="props"
                @change="change"
                :options="options"
                v-model="customer"
                :placeholder="placeholder"
                :remote-method="getOptions"
                :size="size"
                @focus="focus"
                @blur="blur"
                :customOption="true">
    </sky-select>
    <el-button v-if="showBtn && controlButton"
               size="small"
               type="primary"
               @click="allcustomers">全部客户</el-button>
  </div>
</template>
<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import dict from '@/backend/services/dictionary/dictionary';
import { mapGetters } from 'vuex';

export default {
  props: {
    defaultKey: String,
    value: [String, Array, Object],
    disabled: Boolean,
    clearable: {
      default: false,
    },
    placeholder: {
      default: '客户名称',
    },
    size: {
      type: String,
      default: 'small',
    },
    controlButton: {
      type: Boolean,
      default: true,
    },
    runDefaultKey: Function
  },
  components: {
    skySelect,
  },
  data () {
    return {
      filterable: true,
      remote: true,
      options: [],
      props: {
        label: 'value',
        value: 'id',
      },
      customer: this.value,
    };
  },
  computed: {
    ...mapGetters(['customerId']),
    showBtn () {
      return this.customer ? true : false;
    },
  },
  methods: {
    setCustomerName () {
      return new Promise(resolve => {
        this.$store.commit('SET_CUSOMERNAME', '');
        resolve();
      });
    },
    setCustomerId () {
      return new Promise(resolve => {
        this.$store.commit('SET_CUSTOMERID', '');
        resolve();
      });
    },
    // getOptions方法重构：修改为async/await
    getOptions: async function (val) {
      const res = await dict.getCustomerName({ name: val });
      this.options = res.data;
    },
    change (val) {
      let item = this.options.find(item => item.id === val);
      this.$emit('input', this.customer);
      this.$emit('change', item || {});
      if (this.runDefaultKey) this.runDefaultKey(item)
    },
    focus (e) {
      this.$emit('focus', e);
    },
    blur (e) {
      this.$emit('blur', e);
    },
    // 查看全部客户
    async allcustomers () {
      sessionStorage.removeItem('activeWebsiteId');
      this.$store.commit('SET_CUSTOMERID', '');
      this.$store.commit('SET_CUSOMERNAME', '');
      // await this.setCustomerId();
      // await this.setCustomerName();
    },
  },
  watch: {
    value: {
      handler (val) {
        this.customer = val;
      },
      deep: true,
      immediate: true
    },
    defaultKey: {
      handler (val) {
        if (val) {
          this.getOptions(val);
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-select {
	display: flex;
	justify-content: flex-start;
	align-items: center;

	.el-button {
		margin-left: 16px;
	}
}
</style>
